<div id="notfound">
    <div class="notfound">
        <div class="notfound-404">
            <h1>उफ़!</h1>
            <h2>404 - पृष्ठ नहीं मिल सकता है</h2>
        </div>
        <a [routerLink]="['/']">मुख्य पृष्ठ पर जाये</a>
    </div>
</div>